export default {
  Title: 'Date format',
  Label: 'Select date format',
  DDMMYYYY: 'DD/MM/YYYY',
  MMDDYYYY: 'MM/DD/YYYY',
  Save: 'Save',
  Cancel: 'Cancel',
};
